import { Outlet, createFileRoute } from "@tanstack/react-router";

import { useBookingPanel } from "@/features/booking/hooks/use-booking-panel";
import { BookingDetailSheet } from "@/features/booking/modules/booking-detail/booking-detail-sheet";
import { m } from "@/paraglide/messages.js";

/**
 * Every booking page sits under this one: it gives the breadcrumb its "Bookings" step and mounts
 * the booking detail once, so `?bookingId=` opens it from any page.
 */
export const Route = createFileRoute("/(private)/booking")({
  loader: () => ({ crumb: m.booking_nav_label() }),
  component: BookingLayout,
});

function BookingLayout() {
  const { bookingId, occurrenceStart, step, closeBooking } = useBookingPanel();

  return (
    <>
      <Outlet />
      <BookingDetailSheet bookingId={bookingId} occurrenceStart={occurrenceStart} step={step} onClose={closeBooking} />
    </>
  );
}
